"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IEContentLoaded = function (w, callback) {
    var d = w.document;
    var done = false;
    var init = function () {
        if (!done) {
            done = true;
            callback();
        }
    };
    var polling = function () {
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore:next-line
            d.documentElement.doScroll('left');
        }
        catch (e) {
            setTimeout(polling, 50);
            return;
        }
        init();
    };
    polling();
    d.onreadystatechange = function () {
        if (d.readyState === 'complete') {
            d.onreadystatechange = null;
            init();
        }
    };
};
var DOMReady = function (fn) {
    if (document.addEventListener) {
        if (['complete', 'loaded', 'interactive'].includes(document.readyState)) {
            setTimeout(fn, 0);
        }
        else {
            var loadFn_1 = function () {
                document.removeEventListener('DOMContentLoaded', loadFn_1, false);
                fn();
            };
            document.addEventListener('DOMContentLoaded', loadFn_1, false);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore:next-line
    }
    else if (document.attachEvent) {
        IEContentLoaded(window, fn);
    }
};
exports.default = DOMReady;
//# sourceMappingURL=domReady.js.map